import React, { useRef, useState } from 'react'

export const MIN_SCALE = 1
export const MAX_SCALE = 3

const useZoom = () => {
  const [scale, setScale] = useState(1)
  const touchActive = useRef(false)

  const onTouchStart: React.TouchEventHandler<HTMLDivElement> = () => {
    if (touchActive.current) return
    touchActive.current = true
    let initDistance = 0

    const onTouchMove = (e: TouchEvent) => {
      if (e.touches.length !== 2) return
      const currentDistance = getDistance(e.touches)
      if (initDistance === 0) {
        initDistance = currentDistance
        return
      }

      const ratio = currentDistance / initDistance
      initDistance = currentDistance
      setScale(prev => Math.max(MIN_SCALE, Math.min(MAX_SCALE, prev * ratio)))
    }

    const onTouchEnd = () => {
      touchActive.current = false
      initDistance = 0
      window.removeEventListener('touchmove', onTouchMove)
      window.removeEventListener('touchcancel', onTouchEnd)
      window.removeEventListener('touchend', onTouchEnd)
    }

    window.addEventListener('touchmove', onTouchMove, { passive: true })
    window.addEventListener('touchcancel', onTouchEnd)
    window.addEventListener('touchend', onTouchEnd)
  }

  const onWheel: React.WheelEventHandler<HTMLDivElement> = (event) => {
    if (event.ctrlKey) {
      setScale(prev => Math.max(MIN_SCALE, Math.min(MAX_SCALE, prev - event.deltaY * 0.01)))
    }
  }

  const onDbClick = () => {
    setScale(prev => (prev < 2 ? prev + 0.5 : 1))
  }

  const zoomIn = () => {
    setScale(prev => Math.min(MAX_SCALE, prev + 0.2))
  }

  const zoomOut = () => {
    setScale(prev => Math.max(MIN_SCALE, prev - 0.2))
  }

  return {
    scale,
    onTouchStart,
    onDbClick,
    onWheel,
    zoomIn,
    zoomOut
  }
}

const getDistance = (touches: React.TouchList | TouchList) => {
  if (touches.length < 2) return 0
  const dx = touches[0].clientX - touches[1].clientX
  const dy = touches[0].clientY - touches[1].clientY
  return Math.sqrt(dx * dx + dy * dy)
}

export default useZoom